import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11.9999,
		cy: 7.71422,
		r: 3.42857,
		fill: "#A7C4FC"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.14282 15C5.14282 13.3431 6.48597 12 8.14282 12H15.8571C17.514 12 18.8571 13.3431 18.8571 15V18.7143C18.8571 19.2666 18.4094 19.7143 17.8571 19.7143H6.14282C5.59054 19.7143 5.14282 19.2666 5.14282 18.7143V15Z",
		fill: "#89B0FB"
	})]
});
export default SvgIcPerson;
